<template>
	<div v-if="formId && logList.length" class="m-doc-log">
		<c-title>流程</c-title>

		<ul>
			<li v-for="(item, i) in logList" :key="i" class="flex">
				<template v-if="item.is_execute == 1">
					<div v-if="item.execute_state == 9" class="state flex-center" style="background: #f00;"><i class="tf">&#xe60f;</i></div>
					<div v-else class="state flex-center" style="background: #00BD3A;"><i class="tf">&#xe63f;</i></div>
				</template>
				<div v-else-if="item == activeFlow" class="state flex-center" style="background: #FF6900;"><i class="tf">&#xe60c;</i></div>
				<member-icon :icon="item.head_photo" :name="item.executor_realname[0]"></member-icon>
				<div class="flex-grow">
					<div class="flex">
						<div class="flex-grow">
							<span class="desc">{{item.node_name}}</span>
							<p class="name">{{item.executor_realname.join('、')}}</p>
						</div>
						<div v-if="item.execute_date" class="date">{{item.execute_date}}</div>
					</div>
					<div v-if="item.execute_state == 9" class="remark">
						<p>驳回原因：{{item.remark}}</p>
					</div>
				</div>
			</li>
		</ul>

		<dl v-if="carbonList.length">
			<dt>抄送给({{carbonList.length}})</dt>
			<dd class="flex-wrap">
				<member-icon v-for="(person, i) in carbonList" :key="i" :icon="person.head_photo" :name="person.user_realname" text></member-icon>
			</dd>
		</dl>
	</div>
</template>

<script>
	export default {
		name: 'docLog',

		props: {
			formId: [String, Number]
		},

		data() {
			return {
				activeFlow: null,
				logList: [],
				carbonList: []
			}
		},

		watch: {
			formId() {
				this.update();
			}
		},

		methods: {
			update() {
				if (!this.formId) return;
				this.request({
					url: '/flow/workflow/approval/info',
					data: {
						form_id: this.formId
					},
					success: data => {
						let list = [];
						while (data.log_list[0]) {
							list.push(Object.assign({}, data.log_list[0], {
								executor_realname: data.log_list.splice(0, data.log_list.filter(item => item.node_id == data.log_list[0].node_id).length).map(item => item.executor_realname)
							}));
						}
						this.logList = list;
						this.carbonList = data.copy_to_list;
						this.activeFlow = this.logList.find(item => item.is_execute == 0);
						let $base = this.$parent.$children.find(item => item.$options.name == 'docBase');
						if ($base && this.activeFlow) {
							$base.approver = this.activeFlow.executor_realname.join('、');
						}
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-doc-log {
		border-radius: .16rem;
		padding: .1rem .36rem .2rem;
		margin: 0 .2rem .2rem;
		background: #fff;

		&:nth-child(1) {
			margin-top: .2rem;
		}

		ul {
			padding: .2rem 0;

			li {
				gap: .24rem;
				position: relative;

				&:nth-last-child(n+2) {
					min-height: 1.5rem;

					&:before {
						content: '';
						position: absolute;
						left: .38rem;
						top: .86rem;
						bottom: .08rem;
						width: .04rem;
						background: #ccc;
					}
				}

				.state {
					z-index: 1;
					position: absolute;
					left: .52rem;
					top: .52rem;
					width: .28rem;
					height: .28rem;
					border: .06rem solid #fff;
					border-radius: 50%;
					font-size: .18rem;
					color: #fff;
				}

				.desc {
					font-size: .26rem;
					color: #999;
				}

				.name {
					margin-top: .18rem;
					font-size: .3rem;
				}

				.date {
					font-size: .24rem;
					color: #bbb;
				}

				.remark {
					border-radius: .08rem;
					padding: .14rem .24rem;
					margin-top: .2rem;
					line-height: .4rem;
					font-size: .26rem;
					color: #666;
					background: #F9F9F9;
				}
			}
		}

		dl {
			dt {
				line-height: .8rem;
				font-size: .3rem;
				color: #999;
			}

			dd {
				gap: .12rem;
			}
		}
	}
</style>
